import { render, staticRenderFns } from "./ArticlePrioritySettings.vue?vue&type=template&id=dad37464&scoped=true&"
import script from "./ArticlePrioritySettings.vue?vue&type=script&lang=ts&"
export * from "./ArticlePrioritySettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad37464",
  null
  
)

export default component.exports